<template>
  <div>
    <div id="galleryTop" class="swiper-container gallery-top">
      <div class="swiper-wrapper">
        <div v-for="(userPhoto, key) in userPhotos" :key="key" class="swiper-slide" :data-index-slide="key + 1">
          <div class="user-photo">
            <div class="user-photo__info">
              <div class="user-photo__author">
                <GImageUser
                  :username="userPhoto.user && userPhoto.user.name ? userPhoto.user.name : 'SOCO User'"
                  :src="userPhoto.user && userPhoto.user.image ? userPhoto.user.image : ''"
                  class="user-photo_ava-wrapper"
                  class-name="user-photo__author-ava"
                />
                <div class="user-photo__author-info">
                  <span class="user-photo__fullname">{{
                    userPhoto.user && userPhoto.user.name ? userPhoto.user.name : 'SOCO User'
                  }}</span>
                  <div class="user-photo__additional-info">
                    <span class="user-photo__created-at">{{ userPhoto.created_at | relativeTime }}</span
                    ><span class="user-photo__icon-circle"></span>
                    <span :class="['user-level', $options.filters.userLevel(userPhoto.user.user_level)]">{{
                      getSocoLevelName(userPhoto.user.user_level)
                    }}</span>
                  </div>
                </div>
              </div>
              <span class="user-photo__info-slide">{{ slidePaginationNumber }} / {{ totalUserPhoto }} photos</span>
            </div>

            <div class="average-rating--uniform">
              <div class="rating--uniform timeline-review">
                <div
                  :class="`rate-star--uniform rate-star--uniform-${
                    countAverageRating(userPhoto.review.average_rating) * 10
                  } bigest-star`"
                >
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span class="count"
                  >{{
                    countAverageRating(userPhoto.review.average_rating)
                      ? countAverageRating(userPhoto.review.average_rating)
                      : '0.0'
                  }}
                </span>
              </div>
            </div>

            <p
              v-if="userPhoto.review && userPhoto.review.details"
              class="user-photo__details"
              :class="{ 'details-ellipsis': !screen.isDesktop }"
            >
              {{ screen.isDesktop ? trimUserPhotoReviewDetails(userPhoto.review.details) : userPhoto.review.details }}
            </p>

            <div class="user-photo__content">
              <img
                class="user-photo__item swiper-lazy"
                :data-src="mainImage(userPhoto.url) || mainImage(userPhoto.name)"
                :src="mainImage(userPhoto.url) || mainImage(userPhoto.name)"
                alt="user-photo"
              />
              <div class="swiper-lazy-preloader"></div>
            </div>

            <p v-if="userPhoto.description" class="user-photo__caption">
              {{ userPhoto.description }}
            </p>
          </div>
        </div>
      </div>
      <div
        ref="nextMain"
        class="swiper-button-next swiper-button-next--main swiper-button-white"
        :class="{ 'event-none': isProcessingLoadMore }"
        @click.prevent="nextLoadPhoto"
      >
        <GLoaderSpin v-if="isProcessingLoadMore" />
      </div>
      <div class="swiper-button-prev swiper-button-prev--main swiper-button-white"></div>
      <!-- Mobile Condition-->
      <GLoaderSpin v-if="isProcessingLoadMore && !screen.isDesktop" />
    </div>
    <div id="photoThumbsWrapper" class="photo-thumbs-wrapper">
      <div id="photoThumbs" class="swiper-container photo-thumbs">
        <div class="swiper-wrapper">
          <div v-for="(userPhoto, key) in userPhotos" :key="key" class="swiper-slide">
            <img
              v-if="userPhoto.url"
              :data-src="thumbsImage(userPhoto.url)"
              :src="thumbsImage(userPhoto.url)"
              class="photo-thumbs__img swiper-lazy"
              height="80"
              width="80"
              alt="user-photo"
            />
            <div class="swiper-lazy-preloader"></div>
          </div>
        </div>
        <div
          ref="nextThumbs"
          class="swiper-button-next swiper-button-next--thumbs swiper-button-white"
          :class="{ 'event-none': isProcessingLoadMore }"
          @click.prevent="loadUserPhotos"
        >
          <GLoaderSpin v-if="isProcessingLoadMore" />
        </div>
        <div ref="prevThumbs" class="swiper-button-prev swiper-button-prev--thumbs swiper-button-white"></div>
        <!-- Mobile Condition-->
        <GLoaderSpin v-if="isProcessingLoadMore && !screen.isDesktop" />
      </div>
    </div>
  </div>
</template>

<script>
import { socoLevelMixin } from '@/shared/soco-levels';

let galleryTop;
let galleryUserPhotoThumbs;
export default {
  name: 'user-photos-slide',
  mixins: [socoLevelMixin],
  data() {
    return {
      activeThumbMobile: 0,
      showTotalItemMobile: 0,
      limit: 9,
      slidePaginationNumber: 1,
      skip: 0,
      isProcessingLoadMore: false,
    };
  },
  computed: {
    initialIndexSlide() {
      return this.$store.state.productDetail.initialIndexSlide;
    },
    product_id() {
      const productId = this.$route.params.product_id.split('-');
      return productId[0];
    },
    screen() {
      return this.$store.state.screen;
    },
    totalUserPhoto() {
      return this.$store.state.productDetail.totalUserPhoto;
    },
    userPhotos() {
      return this.$store.state.productDetail.userPhotos;
    },
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    checkingUpSlideReachEndState() {
      if (this.totalUserPhoto !== this.userPhotos.length) {
        galleryUserPhotoThumbs.isEnd = false;
      }
    },
    checkingUpSlideArrowState() {
      if (this.$SO.size(this.userPhotos) < this.totalUserPhoto) {
        this.$SO(this.$refs.nextThumbs).removeClass('swiper-button-disabled');
        this.$SO(this.$refs.nextMain).removeClass('swiper-button-disabled');
      }
    },
    initSwiper() {
      const defaultParamThumbs = {
        spaceBetween: 0,
        slidesPerView: 9,
        loop: false,
        freeMode: false,
        loopedSlides: 9,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slidesPerGroup: 9,
        navigation: {
          nextEl: '.swiper-button-next--thumbs',
          prevEl: '.swiper-button-prev--thumbs',
        },
        preloadImages: false,
        lazy: true,
      };

      const defaultParamTop = {
        spaceBetween: 10,
        loop: false,
        loopedSlides: 9,
        navigation: {
          nextEl: '.swiper-button-next--main',
          prevEl: '.swiper-button-prev--main',
        },
        preloadImages: false,
        lazy: true,
      };

      if (!this.screen.isDesktop) {
        defaultParamThumbs.freeMode = true;
        defaultParamThumbs.spaceBetween = 8;
        defaultParamThumbs.slidesPerView = 'auto';
        defaultParamThumbs.loopedSlides = 1;
        defaultParamThumbs.slidesPerGroup = 1;
        // defaultParamThumbs.width = '82px';

        defaultParamTop.loopedSlides = 1;
      }

      galleryUserPhotoThumbs = new Swiper('#photoThumbs', defaultParamThumbs);

      defaultParamTop.thumbs = { swiper: galleryUserPhotoThumbs };

      galleryTop = new Swiper('.gallery-top', defaultParamTop);

      this.slideToIntialIndex();
      this.checkingUpSlideArrowState();

      galleryTop.on('slideChangeTransitionEnd', () => {
        const activeIndex = this.$SO('#galleryTop .swiper-slide-active')[0].getAttribute('data-index-slide');
        this.slidePaginationNumber = activeIndex;
        if (!this.screen.isDesktop) {
          this.checkingUpSlideReachEndState();
        }
      });

      if (this.screen.isDesktop) {
        galleryTop.on('slideNextTransitionEnd', () => {
          const isSlideToNextGroupThumbs = (this.slidePaginationNumber - 1) % 9 === 0;

          if (isSlideToNextGroupThumbs) {
            galleryUserPhotoThumbs.slideTo(this.slidePaginationNumber, 0);
          }
          this.checkingUpSlideArrowState();
        });
      } else {
        galleryUserPhotoThumbs.on('reachEnd', () => {
          if (!this.isProcessingLoadMore) {
            this.loadUserPhotos();
          }
        });
        galleryTop.on('reachEnd', () => {
          if (!this.isProcessingLoadMore) {
            this.loadUserPhotos();
          }
        });
      }
    },
    trimUserPhotoReviewDetails(value) {
      if (value) {
        if (String(value).length > 260) {
          return String(value).substr(0, 260) + '...';
        } else {
          return value;
        }
      }
    },
    countAverageRating(value) {
      if (value) {
        try {
          return value.toFixed(1);
        } catch (error) {
          return value;
        }
      } else {
        return 0;
      }
    },
    loadUserPhotos() {
      const amountUserPhoto = this.$SO.size(this.userPhotos);
      const groupingPositionIndex = Math.ceil(this.slidePaginationNumber / this.limit);

      if (this.totalUserPhoto > this.skip + this.limit && amountUserPhoto <= groupingPositionIndex * this.limit) {
        this.isProcessingLoadMore = true;
        this.skip += this.limit;
        this.$store
          .dispatch('getUserReviewImages', {
            params: {
              limit: this.limit,
              skip: this.skip,
            },
            product_id: this.product_id,
          })
          .then((response) => {
            if (response.status === 200) {
              this.$store.commit('mergeUserPhotos', response.data.data);
            } else {
              this.$store.commit('mergeUserPhotos', []);
            }

            if (this.$store.state.screen.isDesktop) {
              this.$nextTick(() => {
                const nextGroupThumbIndex = this.userPhotos.length - this.limit;
                galleryTop.update();
                galleryUserPhotoThumbs.update();
                galleryUserPhotoThumbs.slideTo(nextGroupThumbIndex, 0);
                galleryTop.slideTo(nextGroupThumbIndex, 0);
                this.checkingUpSlideArrowState();
                this.isProcessingLoadMore = false;
              });
            } else {
              this.$nextTick(() => {
                galleryTop.update();
                galleryUserPhotoThumbs.update();
                this.isProcessingLoadMore = false;
                this.checkingUpSlideReachEndState();
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.$store.commit('mergeUserPhotos', []);
            this.isProcessingLoadMore = false;
          });
      }
    },
    nextLoadPhoto() {
      const isReachEndSlide = Number(this.slidePaginationNumber) === Number(this.userPhotos.length);
      if (isReachEndSlide) {
        this.loadUserPhotos();
      }
    },
    slideTo(key) {
      galleryTop.slideTo(key, 400);
      this.activeThumbMobile = key;
    },
    slideToIntialIndex() {
      if (this.initialIndexSlide) {
        galleryTop.slideTo(this.initialIndexSlide, 10);
      }
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: this.screen.isDesktop ? 'w=600' : 'w=343',
        image: src,
      });
    },
    thumbsImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=80',
        image: src,
      });
    },
  },
};
</script>
